import { render, staticRenderFns } from "./library.vue?vue&type=template&id=679f4aec&scoped=true&"
import script from "./library.vue?vue&type=script&lang=js&"
export * from "./library.vue?vue&type=script&lang=js&"
import style0 from "./library.vue?vue&type=style&index=0&id=679f4aec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679f4aec",
  null
  
)

export default component.exports